var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEvMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 43,
    viewBox: "0 0 52 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9375 14.9783L22.3595 10.0233C23.0457 9.56216 23.8533 9.31479 24.6801 9.3125H32.5411C33.2708 9.3169 33.9867 9.5122 34.6175 9.87897C35.2484 10.2457 35.7723 10.7712 36.1371 11.4032C37.5588 13.7657 38.2278 14.4138 36.3671 18.0307C35.944 18.8406 35.2673 19.4896 34.4405 19.8785C33.6136 20.2674 32.6821 20.3747 31.7885 20.1841L25.0146 18.8461C23.7602 18.5952 21.3559 20.9367 22.3595 23.9473L34.59 28.6514C35.4834 28.9637 36.4563 28.9637 37.3497 28.6514L49.5594 24.93",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5695 8.43167L40.1614 2.68227C39.4238 2.24316 38.5726 2.0322 37.7153 2.07597L22.725 2.95406C21.7902 3.01663 20.9016 3.38382 20.1953 3.99941L12.7734 10.6687C12.2328 11.1596 11.8232 11.7776 11.5817 12.4667L10.5781 15.54",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9777 30.2058C26.4674 32.8497 25.1373 35.2657 23.1762 37.1108C21.2151 38.956 18.7226 40.1366 16.0526 40.4851C13.3825 40.8335 10.6706 40.3322 8.30161 39.0521C5.93264 37.772 4.02703 35.7783 2.85526 33.354C1.68349 30.9296 1.30508 28.1978 1.77376 25.5462C2.24244 22.8946 3.53438 20.458 5.46622 18.5822C7.39806 16.7065 9.87164 15.4868 12.5359 15.0964C15.2001 14.706 17.9196 15.1646 20.3084 16.4073",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.5829V20.4922",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1392 22.5781H12.9578C12.2129 22.5836 11.5003 22.8834 10.9755 23.4122C10.4507 23.9409 10.1562 24.6556 10.1563 25.4006C10.1548 25.9591 10.3215 26.5051 10.6347 26.9675C10.948 27.4299 11.3932 27.7873 11.9124 27.993L16.1775 29.7283C16.784 29.9762 17.2844 30.4288 17.5918 31.0075C17.8991 31.5861 17.9939 32.2542 17.8597 32.8955C17.7255 33.5369 17.3707 34.1108 16.8571 34.5177C16.3435 34.9245 15.7035 35.1384 15.0485 35.1223H10.8671",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 37.2079V35.1172",
    stroke: "#1E196A",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEvMoney);
export default __webpack_public_path__ + "static/media/icon-ev-money.bdafbdb562a2bc006a6b5b0cd6febdfe.svg";
export { ForwardRef as ReactComponent };